import * as MetasearchLoader from './components/MetasearchLoader.css';

export default {
	MetasearchLoader
};
